import { USER_ROLES } from '@didaskill/domain/users/constants';

const EXTERNAL_EDITOR_MANAGEMENT_ROLES: USER_ROLES[] = [
  USER_ROLES.ADMIN,
  USER_ROLES.CONCEPTION,
  USER_ROLES.SUPER_ADMIN,
];

/**
 * Returns whether the user can manage external editor assignments.
 *
 * @param userRoles - Roles of the user who requests to add or remove a role.
 * @returns True when the user may manage external editors.
 */
function canUserManageExternalEditorRole(userRoles: USER_ROLES[]): boolean {
  return userRoles.some((userRole) => EXTERNAL_EDITOR_MANAGEMENT_ROLES.includes(userRole));
}

/**
 * Check if user can remove a role
 *
 * @param userRoles - Roles of the user who requests to remove a role from another user.
 * @param role - Role to be removed.
 * @returns True if the user can remove the role, false otherwise.
 */
export function canUserAddOrRemoveRole(userRoles: USER_ROLES[], role: USER_ROLES): boolean {
  if (role === USER_ROLES.SUPER_ADMIN) {
    return false;
  }

  if (userRoles.includes(USER_ROLES.SUPER_ADMIN)) {
    return true;
  }

  const hasAdminOrAdministrative =
    userRoles.includes(USER_ROLES.ADMIN) || userRoles.includes(USER_ROLES.ADMINISTRATIVE);

  switch (role) {
    case USER_ROLES.ADMIN:
    case USER_ROLES.SUPPORT:
      return false;
    case USER_ROLES.EXTERNAL_EDITOR:
      return hasAdminOrAdministrative || canUserManageExternalEditorRole(userRoles);
    default:
      return hasAdminOrAdministrative;
  }
}
